import { PATH_NAME_ADULT } from '@/common/resources/router.const'

export default [
  {
    path: '/adult',
    name: PATH_NAME_ADULT,
    alias: '/player/adult.html',
    components: {
      adult: () => import('@/components/adult/Adult')
    }
  }
 ]
